import React from 'react';
import { Modal, Descriptions } from 'antd';
import moment from 'moment';
import { StyledCard } from './stlyed';
import { createTempDashboard } from '@store/tempDashboard/actions';
import { DASHBOARD_TYPE } from '@utils/constants';
import { getMetricDisplayName } from '@src/utils/metrics';
const { confirm } = Modal;

export const AlertDescription = ({ info }) => {
  const displayName = getMetricDisplayName({ metricKey: info.metric });
  return (
    <StyledCard title={<h4>Manual Alert: {info.name}</h4>}>
      <Descriptions size="small" layout="vertical" column={2}>
        <Descriptions.Item label={displayName}>{info.rule}</Descriptions.Item>
        <Descriptions.Item label="Audience Threshold">{info.threshold}</Descriptions.Item>
        <Descriptions.Item label="Start Time - End Time">{info.timeRange}</Descriptions.Item>
        <Descriptions.Item label="Cooldown Period">{info.cooldown}</Descriptions.Item>
        <Descriptions.Item label="Priority">{info.priority}</Descriptions.Item>
      </Descriptions>
    </StyledCard>
  );
};

export const createEventDashboard = (dispatch, { event, alert, info }) => {
  const { id, name, rule, isAdvanced } = alert.filter;

  const appliedFilter = {
    fid: id,
    name,
    rule,
    isAdvanced,
  };

  const preferEndTime = moment(event.time).add(3, 'hour');
  const now = moment();
  const endTime = (now.isAfter(preferEndTime) ? preferEndTime : now).startOf('minute');

  const interval = {
    from: moment(endTime).subtract(6, 'hours'),
    to: endTime,
  };

  const dashboard = {
    common: {
      appliedFilters: [appliedFilter],
      interval,
    },
    ['module:trends']: {
      alerts: {
        selectedEvent: { ...event, alert },
      },
    },
  };

  dispatch(
    createTempDashboard(
      DASHBOARD_TYPE.ALERT_DIAGNOSTICS,
      dashboard,
      `Alert: ${alert.name}`,
      { newBrowserTab: true },
      ),
  );
};

export const confirmAlertDrilldown = (dispatch, data) => {
  const { info } = data;

  confirm({
    title: `Drilldown to this event?`,
    // icon: <ExclamationCircleFilled />,
    content: <AlertDescription info={info} />,
    onOk() {
      createEventDashboard(dispatch, data);
    },
    onCancel() {
      // pass
    },
    width: 550,
    bodyStyle: {
      width: 500,
    },
  });
};
